import {
  TEDLRFakturaDelAttestMinaStatusEnum,
  TEDLRFakturaAttestSTATUSEnum,
  TEDLRFakturaAttestAttestTypEnum,
  TEDLRLeverantorfakturaMOMSHANTERINGEnum,
} from '../../../../../../globalQueryTypes';
import {
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All,
  FakturaDelQuery_node_TEDLRFakturaDel,
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura,
} from '../Queries/_QueryTypes/FakturaDelQuery';
import {
  IEditMenuActionParams,
  DisabledType,
  getEditMenuSaveButtonDisabled,
  IValidateFn,
  IFormData,
  IFieldValidations,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { getFormUpdateValue } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import { FakturaDelType__Associations_Fakturaattest_All } from '../Queries/_QueryTypes/FakturaDelType';
import { uniq } from 'ramda';
import { mergeBusinessDataFormValues } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { IBusinessDataFormContext } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { ReservForQuery_db_LRAttestrattReserv_All } from '../../Attestant/Components/ReservFor/Queries/_QueryTypes/ReservForQuery';
import { isTillaggsinfoError } from '../Components/Kontering/Components/Tillaggsinfo/Utils/TillaggsinfoUtils';
import { AUTOMATICALLY_ADDED_VALUE_PREFIX } from '../Components/FakturaDelContextManager/FakturaDelContextManager';
import {
  Fakturabilder_node_TEDLRLeverantorfaktura,
  Fakturabilder_node_TEDLRLeverantorfaktura__Associations_Fakturasidor,
  Fakturabilder_node_TEDLRLeverantorfaktura__Associations_Registrering,
} from '../../LeverantorFaktura/Queries/Fakturabilder/_QueryTypes/Fakturabilder';

export enum ButtonTypeEnum {
  ATTESTERA = 'ATTESTERA',
  ATERTA = 'ATERTA',
}

export const isRetakeHidden =
  (
    button: ButtonTypeEnum,
    userSign: string,
    reservForData: ReservForQuery_db_LRAttestrattReserv_All[] | null | undefined
  ) =>
  (params: IEditMenuActionParams) => {
    const fakturaAttester = params.businessDataFormContext.data?._Associations
      ?.Fakturaattest_All as FakturaDelType__Associations_Fakturaattest_All[];
    const minFakturaAttest = getAktuellFakturaAttest(
      fakturaAttester,
      reservForData,
      userSign,
      null,
      ButtonTypeEnum.ATERTA
    );

    const attestMinaStatus =
      params.businessDataFormContext.data?.AttestMinaStatus;

    const jagAttesterar =
      attestMinaStatus ===
        TEDLRFakturaDelAttestMinaStatusEnum.BESLUTSATTESTERAS ||
      attestMinaStatus ===
        TEDLRFakturaDelAttestMinaStatusEnum.MOTTAGNINGSATTESTERAS ||
      attestMinaStatus ===
        TEDLRFakturaDelAttestMinaStatusEnum.KONTROLLATTESTERAS;

    const hasAttesterat =
      minFakturaAttest?.aktuellFakturaAttest?.STATUS ===
        TEDLRFakturaAttestSTATUSEnum.ATTESTERAD && !jagAttesterar;

    const underUtredning =
      attestMinaStatus ===
        TEDLRFakturaDelAttestMinaStatusEnum.UNDER_UTREDNING &&
      minFakturaAttest?.aktuellFakturaAttest?.STATUS ===
        TEDLRFakturaAttestSTATUSEnum.UTDELAD;

    const canRetake = hasAttesterat || underUtredning;

    if (button === ButtonTypeEnum.ATTESTERA) {
      return canRetake;
    }

    return !canRetake;
  };

type retakeButtonFunction = (
  reservFor: ReservForQuery_db_LRAttestrattReserv_All[] | null | undefined,
  userSign: string
) => (
  editMenuActionParams: IEditMenuActionParams,
  loading: boolean
) => DisabledType;

export const isRetakeButtonDisabled: retakeButtonFunction =
  (
    reservFor: ReservForQuery_db_LRAttestrattReserv_All[] | null | undefined,
    userSign: string
  ) =>
  (params, loading) => {
    const businessDataFormContext = params.businessDataFormContext;
    const attestTyp = getMinAttestTyp(businessDataFormContext.data);

    const minFakturaAttest = getAktuellFakturaAttest(
      businessDataFormContext.data?._Associations?.Fakturaattest_All,
      reservFor,
      userSign,
      attestTyp,
      ButtonTypeEnum.ATERTA
    );

    if (params.businessDataFormContext.mutationLoading || loading) {
      return true;
    }

    let disabledReason: DisabledType;

    const certifiers =
      params.businessDataFormContext.data?._Associations?.Fakturaattest_All;

    const currentUser:
      | FakturaDelType__Associations_Fakturaattest_All
      | undefined = certifiers?.find(
      (certifier: FakturaDelType__Associations_Fakturaattest_All): boolean => {
        // Kolla om den inloggade användaren är reserv
        if (minFakturaAttest.isReserv) {
          return (
            certifier._Associations?.Attestratt?.id ===
            minFakturaAttest.reservAttestratt.attestrattID
          );
        } else {
          return (
            certifier._Associations?.Attestratt?._Associations?.Attestant?._Associations?.Anvandare?.SIGNATURE.toLocaleLowerCase() ===
            userSign.toLocaleLowerCase()
          );
        }
      }
    );

    const otherCertifiers:
      | FakturaDelType__Associations_Fakturaattest_All[]
      | undefined = certifiers?.filter(
      (certifier: FakturaDelType__Associations_Fakturaattest_All): boolean => {
        return (
          certifier._Associations?.Attestratt?._Associations?.Attestant?._Associations?.Anvandare?.SIGNATURE.toLocaleLowerCase() !==
          userSign.toLocaleLowerCase()
        );
      }
    );

    let otherCertifiersHasCertified = false;

    if (
      otherCertifiers &&
      currentUser?.AttestTyp ===
        TEDLRFakturaAttestAttestTypEnum.MOTTAGNINGSATTEST
    ) {
      otherCertifiersHasCertified = otherCertifiers
        .filter(
          it => it.AttestTyp === TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST
        )
        .some(it => it.STATUS === TEDLRFakturaAttestSTATUSEnum.ATTESTERAD);
    }

    if (
      otherCertifiers &&
      currentUser?.AttestTyp === TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST
    ) {
      otherCertifiersHasCertified = otherCertifiers
        .filter(
          it => it.AttestTyp === TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST
        )
        .some(it => it.STATUS === TEDLRFakturaAttestSTATUSEnum.ATTESTERAD);
    }

    const attestMinaStatus =
      params.businessDataFormContext.data?.AttestMinaStatus;

    const jagAttesterar =
      attestMinaStatus ===
        TEDLRFakturaDelAttestMinaStatusEnum.BESLUTSATTESTERAS ||
      attestMinaStatus ===
        TEDLRFakturaDelAttestMinaStatusEnum.MOTTAGNINGSATTESTERAS ||
      attestMinaStatus ===
        TEDLRFakturaDelAttestMinaStatusEnum.KONTROLLATTESTERAS;

    const hasCertified =
      currentUser?.STATUS === TEDLRFakturaAttestSTATUSEnum.ATTESTERAD &&
      !jagAttesterar;

    const canRetake =
      attestMinaStatus ===
        TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__EJ_DEFINITIVBOKAD &&
      hasCertified;

    if (otherCertifiersHasCertified && !isDefinitelyBooked(attestMinaStatus)) {
      if (!disabledReason) {
        return (
          <div>Du kan inte återta en attest som någon annan har attesterat</div>
        );
      } else if (Array.isArray(disabledReason)) {
        disabledReason.push(
          <div>Du kan inte återta en attest som någon annan har attesterat</div>
        );
      }
    }

    if (!canRetake && hasCertified && isDefinitelyBooked(attestMinaStatus)) {
      if (!disabledReason) {
        return <div>Du kan inte återta en definitivbokad attest</div>;
      } else if (Array.isArray(disabledReason)) {
        disabledReason.push(
          <div>Du kan inte återta en definitivbokad attest</div>
        );
      }
    }

    if (jagAttesterar) {
      if (!disabledReason) {
        return <div>Du kan inte återta en ej attesterad faktura </div>;
      } else if (Array.isArray(disabledReason)) {
        disabledReason.push(
          <div>Du kan inte återta en ej attesterad faktura</div>
        );
      }
    }

    return disabledReason;
  };

export const retakeFakturaattest =
  (
    reservFor: ReservForQuery_db_LRAttestrattReserv_All[] | null | undefined,
    userSign: string
  ) =>
  ({ businessDataFormContext, editMenuOnCancel }: IEditMenuActionParams) => {
    const attestTyp = getMinAttestTyp(businessDataFormContext.data);

    const minFakturaAttest = getAktuellFakturaAttest(
      businessDataFormContext.data?._Associations?.Fakturaattest_All,
      reservFor,
      userSign,
      attestTyp,
      ButtonTypeEnum.ATERTA
    );

    let newValue = mergeBusinessDataFormValues(
      businessDataFormContext.formState.values,
      getFormUpdateValue(
        [
          [
            {
              operation: 'OwnFields',
              values: {
                EXTRA_STATUS: null,
              },
            },
            {
              operation: 'Update_Values',
              associationName: 'Fakturaattest',
              id: minFakturaAttest.aktuellFakturaAttest?.id ?? '',
              values: {
                STATUS: TEDLRFakturaAttestSTATUSEnum.UTDELAD,
                STATUS_DATUM: new Date().toLocaleDateString('sv-SE'),
                STATUS_TID: new Date().toLocaleTimeString('sv-SE'),
                // Blankas ut då det inte ska finnas någon reserv när man återtar
                RESERV_ID: null,
                RESERV_LOPNR: null,
              },
            },
          ],
          [
            {
              associationName: 'UtredningAttest',
              operation: 'Ref',
              id: null,
            },
          ],
        ],
        businessDataFormContext.data
      )
    );

    businessDataFormContext.saveForm(newValue, () => {
      businessDataFormContext.formStateDispatch({ type: 'VALIDATE' });
    });
  };

const isDefinitelyBooked = (
  attestMinaStatus: TEDLRFakturaDelAttestMinaStatusEnum
) => {
  return (
    attestMinaStatus ===
      TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__SPARRAD ||
    attestMinaStatus ===
      TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__PA_VAG_TILL_BETALNING ||
    attestMinaStatus ===
      TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__MAKULERAD ||
    attestMinaStatus ===
      TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__DELBETALD ||
    attestMinaStatus ===
      TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__DEFINITIVBOKAD ||
    attestMinaStatus === TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__BETALD
  );
};

export const isSaveButtonDisabled = (
  businessDataFormContext: IBusinessDataFormContext,

  loading: boolean
): DisabledType => {
  if (businessDataFormContext?.mutationLoading || loading) {
    return true;
  }
  let disabledReason: DisabledType;

  if (businessDataFormContext) {
    const filteredValidationMessages =
      businessDataFormContext.formState.validation.filter(error => {
        if (typeof error === 'object') {
          return (
            !error.message?.includes('Måste anges') && //Olika formuleringar för fel med kombination/kombvilkor och fel enligt kodbeh i som skapas i getKodbehErrors
            !error.message?.includes('måste anges') &&
            !error.message?.includes('Kontering saknas') &&
            !error.message?.includes('Utanför kodbehörighet') &&
            !error.message?.includes('Du kan inte attestera hela beloppet') &&
            !error.message?.includes(
              'Du behöver attestera en del av beloppet'
            ) &&
            !error.message?.includes('Saknar värde') &&
            !error.message?.includes('Du har inte kvitterat meddelande från') &&
            !error.message?.includes('Utanför dina kodbehörigheter') &&
            !error.message?.includes('Baskonto saknas') &&
            !error.message?.includes('Belopp får ej vara 0') &&
            !error.message?.includes(
              'Måste ange om du vill registerföra förbrukningsinventariet'
            ) &&
            !error.message?.includes('Beslutsattestant saknas') &&
            !error.message?.includes('får ej kombineras med') &&
            !error.message?.includes('Du får inte attestera belopp över') &&
            !error.message?.includes('Minst två olika attestanter krävs') &&
            !error.message?.includes(
              'Det saknas beslutsattestant på denna fakturadel'
            ) &&
            !error.message?.includes('T o m datum saknar värde') &&
            !error.message?.includes('Fr o m datum saknar värde') &&
            !error.message?.includes('Ingående momssats saknar värde') &&
            !error.message?.includes(
              'Fakturans tolkade momsbelopp är 0 kr och därför ska ingen momssats anges på konteringsraderna'
            )
          );
        }
        return true;
      });
    disabledReason = getEditMenuSaveButtonDisabled(
      filteredValidationMessages,
      businessDataFormContext?.formState.formHasChanged ?? false
    );
  }

  const hasAddedMessages =
    businessDataFormContext?.formState.values._Associations?.Faktura_Values
      ?._Associations?.Attestmeddelande_Add_Values;
  const hasDeletedMessages =
    businessDataFormContext?.formState.values._Associations?.Faktura_Values
      ?._Associations?.Attestmeddelande_Delete_Values;

  const attestMinaStatus = businessDataFormContext?.data?.AttestMinaStatus;

  const jagAttesterar =
    attestMinaStatus ===
      TEDLRFakturaDelAttestMinaStatusEnum.BESLUTSATTESTERAS ||
    attestMinaStatus ===
      TEDLRFakturaDelAttestMinaStatusEnum.MOTTAGNINGSATTESTERAS ||
    attestMinaStatus === TEDLRFakturaDelAttestMinaStatusEnum.KONTROLLATTESTERAS;

  if (
    !jagAttesterar &&
    businessDataFormContext?.formState.formHasChanged &&
    !hasAddedMessages &&
    !hasDeletedMessages
  ) {
    if (!disabledReason) {
      return <div>Du attesterar inte denna faktura</div>;
    } else if (Array.isArray(disabledReason)) {
      disabledReason.push(<div>Du attesterar inte denna faktura</div>);
    }
  }

  return Array.isArray(disabledReason)
    ? disabledReason.length > 0
      ? uniq(disabledReason)
      : undefined
    : disabledReason
    ? disabledReason
    : undefined;
};

export const isAttesteraButtonDisabled = (
  businessDataFormContext: IBusinessDataFormContext<any>,
  loading: boolean
): DisabledType => {
  if (
    businessDataFormContext?.mutationLoading ||
    businessDataFormContext?.formState.loading ||
    loading
  ) {
    return true;
  }

  let validation: IFieldValidations = [];

  validation =
    businessDataFormContext?.formState.validation.filter(
      error => error.type === 'Error'
    ) ?? [];

  const attestMinaStatus = businessDataFormContext?.data?.AttestMinaStatus;

  const validationErrors =
    attestMinaStatus ===
    TEDLRFakturaDelAttestMinaStatusEnum.MOTTAGNINGSATTESTERAS
      ? businessDataFormContext?.formState.validation.filter(
          error => !isTillaggsinfoError(error)
        )
      : businessDataFormContext?.formState.validation;

  let disabledReason = getEditMenuSaveButtonDisabled(
    validationErrors ?? [],
    businessDataFormContext?.formState.formHasChanged ?? false
  );

  if (Array.isArray(disabledReason)) {
    disabledReason = disabledReason.filter(
      reason => reason.key !== 'Inga ändringar gjorda'
    );
  }

  const jagAttesterar =
    attestMinaStatus ===
      TEDLRFakturaDelAttestMinaStatusEnum.BESLUTSATTESTERAS ||
    attestMinaStatus ===
      TEDLRFakturaDelAttestMinaStatusEnum.MOTTAGNINGSATTESTERAS ||
    attestMinaStatus === TEDLRFakturaDelAttestMinaStatusEnum.KONTROLLATTESTERAS;

  if (!jagAttesterar) {
    let myDisabledReason: DisabledType;

    switch (attestMinaStatus) {
      case TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__HOS_ANNAN_ATTESTANT:
        myDisabledReason = <div>Du har redan attesterat denna fakturadel</div>;
        break;
      case TEDLRFakturaDelAttestMinaStatusEnum.EJ_ATTESTERAD__HOS_ANNAN_ATTESTANT:
        myDisabledReason = <div>Någon annan attesterar denna fakturadel</div>;
        break;
      default:
        myDisabledReason = (
          <div>Du har inte rätt status för att attestera denna fakturadel</div>
        );
        break;
    }

    if (Array.isArray(disabledReason)) {
      disabledReason?.push(myDisabledReason);
    } else {
      disabledReason = myDisabledReason;
    }
  }

  if (validation.length > 0) {
    let myDisabledReason: DisabledType;

    myDisabledReason = validation.map(val => (
      <div key={val.message}>{val.message}</div>
    ));

    if (Array.isArray(disabledReason)) {
      myDisabledReason.forEach(reason => {
        if (Array.isArray(disabledReason)) {
          disabledReason?.push(reason);
        }
      });
    } else {
      disabledReason = myDisabledReason;
    }

    // Vi har annan validering som täcker fallet där man är sista beslutsattestant detta felmeddelandet är för att vi ska få korrekt meddelande på raden
    disabledReason = disabledReason?.filter(
      error => !error.props.children.includes('Beslutsattestant saknas')
    );
  }

  return Array.isArray(disabledReason)
    ? disabledReason.length > 0
      ? uniq(disabledReason)
      : undefined
    : disabledReason
    ? disabledReason
    : undefined;
};

export const getAttesteraFakturadelUpdateValue = (
  businessDataFormContext: IBusinessDataFormContext<any>,
  userSign: string,
  reservFor: ReservForQuery_db_LRAttestrattReserv_All[] | null | undefined
): IFormData | undefined => {
  const attestTyp = getMinAttestTyp(businessDataFormContext?.data);

  const minFakturaAttest = getAktuellFakturaAttest(
    businessDataFormContext?.data?._Associations?.Fakturaattest_All,
    reservFor,
    userSign,
    attestTyp,
    ButtonTypeEnum.ATTESTERA
  );

  if (minFakturaAttest) {
    let newValue = mergeBusinessDataFormValues(
      businessDataFormContext?.formState.values
        ? businessDataFormContext?.formState.values
        : {},
      getFormUpdateValue(
        [
          {
            operation: 'Update_Values',
            associationName: 'Fakturaattest',
            id: minFakturaAttest.aktuellFakturaAttest?.id ?? '',
            values: {
              STATUS: 'ATTESTERAD',
              STATUS_DATUM: new Date().toLocaleDateString('sv-SE'),
              STATUS_TID: new Date().toLocaleTimeString('sv-SE'),
              RESERV_ID: minFakturaAttest.reservAttestratt.attestomradeId,
              RESERV_LOPNR: minFakturaAttest.reservAttestratt.attestrattLopnr,
            },
          },
        ],
        businessDataFormContext?.data
      )
    );

    return newValue;
  }

  return undefined;
};

export const attesteraFakturadel = (
  businessDataFormContext: IBusinessDataFormContext<any>,
  userSign: string,
  reservFor: ReservForQuery_db_LRAttestrattReserv_All[] | null | undefined
) => {
  const newValue = getAttesteraFakturadelUpdateValue(
    businessDataFormContext,
    userSign,
    reservFor
  );

  if (newValue) {
    businessDataFormContext?.saveForm(newValue);
  }
};

const isInDateInterval = (
  reserv: ReservForQuery_db_LRAttestrattReserv_All
): boolean => {
  const dateFrom = reserv.DATUM_FROM;
  const dateTo = reserv.TomDatum;
  const currentDate = new Date().toLocaleDateString('sv-SE');

  return (
    Date.parse(dateFrom) <= Date.parse(currentDate) &&
    Date.parse(currentDate) <= Date.parse(dateTo)
  );
};

const getReservAttestRatt = (
  ordinarieAttestRattId: string | undefined,
  reservFor: ReservForQuery_db_LRAttestrattReserv_All[] | null | undefined
): IReservAttestRatt => {
  let reservObj;
  if (reservFor) {
    for (let index = 0; index < reservFor.length; index++) {
      const reserv = reservFor[index];
      if (
        reserv._Associations?.Attestratt?.id === ordinarieAttestRattId &&
        isInDateInterval(reserv)
      ) {
        reservObj = reserv;
        break;
      }
    }
  }

  if (reservObj) {
    return {
      id: reservObj._Associations?.Reserv?.id,
      attestomradeId: reservObj._Associations?.Reserv?.ATTESTOMRADE_ID,
      attestrattLopnr: reservObj._Associations?.Reserv?.LOPNR,
      attestrattID: reservObj._Associations?.Attestratt?.id,
      ordinareAttestant:
        reservObj._Associations?.Attestratt?._Associations?.Attestant
          ?.BENAMNING,
    };
  }
  return {
    id: undefined,
    attestomradeId: undefined,
    attestrattID: undefined,
    attestrattLopnr: undefined,
    ordinareAttestant: undefined,
  };
};

/**
 *
 * @param myAttestrattId
 * @param reservFor
 * @returns Alla attestanter som given attestant är reserv för
 */
const getWhoAttestIsReserveTo = (
  myAttestrattId: string | undefined,
  reservFor: ReservForQuery_db_LRAttestrattReserv_All[] | null | undefined
) => {
  let result: ReservForQuery_db_LRAttestrattReserv_All[] | undefined =
    undefined;
  if (myAttestrattId && reservFor) {
    result = reservFor.filter(
      reserver => reserver._Associations?.Reserv?.id === myAttestrattId
    );
  }
  return result;
};

const getAktuellFakturaAttestInfo = (
  attest: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All,
  reservAttestRatt: IReservAttestRatt,
  isReserv: boolean
): IAktuellFakturaAttestInfo => {
  return {
    aktuellFakturaAttest: attest,
    isReserv: isReserv,
    ordinarieAttestratt: { id: attest?._Associations?.Attestratt?.id ?? null },
    reservAttestratt: reservAttestRatt,
  };
};

interface IReservAttestRatt {
  id: string | undefined;
  /**
   * Attestområde
   */
  attestomradeId: number | undefined;
  /**
   * Attesträtt löpnummer reserv
   */
  attestrattLopnr: number | undefined;
  /**
   * Reservens attesträtt
   */
  attestrattID: string | null | undefined;
  /**
   * Benämning på ordinarie attestant
   */
  ordinareAttestant: string | null | undefined;
}
export interface IAktuellFakturaAttestInfo {
  //** Den aktuella attesten */
  aktuellFakturaAttest: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All | null;
  /** Attesträtt för aktuell användare, är antingen attesträtten för den ordinarie attestanten eller för reserv */
  ordinarieAttestratt: {
    id: string | null;
  };
  reservAttestratt: IReservAttestRatt;
  isReserv: Boolean;
}

export const getAktuellFakturaAttest = (
  fakturaAttester: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[],
  reservFor: ReservForQuery_db_LRAttestrattReserv_All[] | null | undefined,
  userSign: string,
  attestTyp: TEDLRFakturaAttestAttestTypEnum | null,
  caller?: ButtonTypeEnum
): IAktuellFakturaAttestInfo => {
  let result: IAktuellFakturaAttestInfo = {
    aktuellFakturaAttest: null,
    ordinarieAttestratt: { id: null },
    reservAttestratt: {
      id: undefined,
      attestomradeId: undefined,
      attestrattID: undefined,
      attestrattLopnr: undefined,
      ordinareAttestant: undefined,
    },
    isReserv: false,
  };

  if (fakturaAttester) {
    for (
      let attestIndex = 0;
      attestIndex < fakturaAttester.length;
      attestIndex++
    ) {
      const attest = fakturaAttester[attestIndex];
      const currentAttestRattId = attest?._Associations?.Attestratt?.id;
      const reservAttestRatt = getReservAttestRatt(
        currentAttestRattId,
        reservFor
      );

      const isMyAttest =
        attest._Associations?.Attestratt?._Associations?.Attestant?._Associations?.Anvandare?.SIGNATURE?.toLocaleLowerCase() ===
        userSign.toLocaleLowerCase();

      if (attest.STATUS !== TEDLRFakturaAttestSTATUSEnum.ATTESTERAD) {
        if (
          isMyAttest &&
          (attest.AttestTyp === attestTyp || attestTyp == null)
        ) {
          return getAktuellFakturaAttestInfo(attest, reservAttestRatt, false);
        }
        // TODO: attestTyp == null - vad gör denna?
        else if (
          reservAttestRatt.id &&
          (attest.AttestTyp === attestTyp || attestTyp == null)
        ) {
          return getAktuellFakturaAttestInfo(attest, reservAttestRatt, true);
        }
      } else if (caller && caller === ButtonTypeEnum.ATERTA) {
        //Ta fram alla attestanter som given attestant är reserv för.
        const reserves = getWhoAttestIsReserveTo(
          attest._Associations?.Attestratt?.id,
          reservFor
        );
        if (reserves && reserves.length > 0) {
          let attesteradReserv:
            | ReservForQuery_db_LRAttestrattReserv_All
            | undefined = undefined;
          // Leta igenom en och ta den första reserven som har status attesterad (Höger till vänster i attestlistan).
          for (let index = reserves.length; index > 0; index--) {
            const reserve = reserves[index - 1];
            const reservAttest = fakturaAttester.find(
              attest =>
                attest._Associations?.Attestratt?.id ===
                reserve._Associations?.Attestratt?.id
            );

            if (
              reservAttest?.STATUS === TEDLRFakturaAttestSTATUSEnum.ATTESTERAD
            ) {
              attesteradReserv = reserve;
              break;
            }
          }

          if (attesteradReserv != undefined) {
            const reservIndex = fakturaAttester.findIndex(
              attest =>
                attest._Associations?.Attestratt?.id ===
                attesteradReserv?._Associations?.Attestratt?.id
            );

            // Ligger reservern efter angiven attest i attestkedjan?
            if (reservIndex > attestIndex) {
              const attesteradReservAttestratt: IReservAttestRatt = {
                id: attesteradReserv._Associations?.Reserv?.id,
                attestomradeId:
                  attesteradReserv._Associations?.Reserv?.ATTESTOMRADE_ID,
                attestrattLopnr: attesteradReserv._Associations?.Reserv?.LOPNR,
                attestrattID: attesteradReserv._Associations?.Attestratt?.id,
                ordinareAttestant:
                  attesteradReserv._Associations?.Attestratt?._Associations
                    ?.Attestant?.BENAMNING,
              };

              result.aktuellFakturaAttest = fakturaAttester[reservIndex];
              result.isReserv = true;
              result.ordinarieAttestratt.id = currentAttestRattId ?? null;
              result.reservAttestratt = attesteradReservAttestratt;
              return result;
            } else {
              return getAktuellFakturaAttestInfo(
                attest,
                reservAttestRatt,
                false
              );
            }
          } else {
            return getAktuellFakturaAttestInfo(attest, reservAttestRatt, false);
          }
        } else if (
          isMyAttest &&
          (attest.AttestTyp === attestTyp || attestTyp == null)
        ) {
          // Är inte reserv till några attester
          return getAktuellFakturaAttestInfo(attest, reservAttestRatt, false);
        } else if (
          reservAttestRatt.id &&
          (attest.AttestTyp === attestTyp || attestTyp == null)
        ) {
          // Ta den sista reservern
          result = getAktuellFakturaAttestInfo(attest, reservAttestRatt, true);
        }
      }
    }
  }
  return result;
};

export const getMinAttestTyp = (
  fakturaDel: FakturaDelQuery_node_TEDLRFakturaDel
): TEDLRFakturaAttestAttestTypEnum | null => {
  switch (fakturaDel?.AttestMinaStatus) {
    case TEDLRFakturaDelAttestMinaStatusEnum.BESLUTSATTESTERAS:
      return TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST;
    case TEDLRFakturaDelAttestMinaStatusEnum.MOTTAGNINGSATTESTERAS:
      return TEDLRFakturaAttestAttestTypEnum.MOTTAGNINGSATTEST;
    case TEDLRFakturaDelAttestMinaStatusEnum.KONTROLLATTESTERAS:
      return TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST;
  }

  return null;
};

export const isAutomaticallyAdded = (value: { id: string } | undefined) => {
  return Boolean(value?.id.startsWith(AUTOMATICALLY_ADDED_VALUE_PREFIX));
};

export const sortFakturattestByAttestant = (
  a: { Attestant: string | null },
  b: { Attestant: string | null }
): number => {
  if (a?.Attestant && b?.Attestant) {
    if (a.Attestant < b.Attestant) {
      return -1;
    }
    if (a.Attestant > b.Attestant) {
      return 1;
    }
    return 0;
  }
  return 0;
};

export const validateMessage: IValidateFn = ({ values }) => {
  const deletedValues =
    values?._Associations?.Faktura_Values?._Associations
      ?.Attestmeddelande_Delete_Values;

  const addValues =
    values?._Associations?.Faktura_Values?._Associations
      ?.Attestmeddelande_Add_Values;

  const notDeletedAddValues = addValues?.filter((addedValue: any) => {
    return !deletedValues?.some((deletedValue: any) => {
      return deletedValue.id === addedValue.id;
    });
  });

  const realAddedValue = notDeletedAddValues?.find((update: any) => {
    return update?.MEDDELANDE?.trim() === '';
  });

  if (realAddedValue) {
    return [
      {
        fieldName: realAddedValue.id,
        message: 'Meddelandet kan inte vara tomt',
        type: 'Error',
      },
    ];
  }
  return [];
};

export const getBildFaktura = (
  faktura:
    | FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura
    | null
    | undefined
): Fakturabilder_node_TEDLRLeverantorfaktura => {
  const imageInvoice: Fakturabilder_node_TEDLRLeverantorfaktura = {
    SkannadSvefaktura: faktura?.SkannadSvefaktura ?? null,
    __typename: 'TEDLRLeverantorfaktura',
    _version: faktura?._version ?? 0,
    id: faktura?.id ?? '',
    DefAnkVernr: faktura?.DefAnkVernr ?? '',
    _Associations: {
      id: '',
      __typename: 'TEDLRLeverantorfakturaAssociations',
      Fakturasidor:
        (faktura?._Associations
          ?.Fakturasidor as Fakturabilder_node_TEDLRLeverantorfaktura__Associations_Fakturasidor[]) ??
        null,
      Registrering:
        (faktura?._Associations
          ?.Registrering as Fakturabilder_node_TEDLRLeverantorfaktura__Associations_Registrering) ??
        null,
    },
  };

  return imageInvoice;
};

export const getKonteringRadtyp = (
  momshantering: TEDLRLeverantorfakturaMOMSHANTERINGEnum | null,
  registreratMomsBelopp: number,
  momspliktigVerksamhet: boolean
): number => {
  if (
    momshantering === TEDLRLeverantorfakturaMOMSHANTERINGEnum.EJ_HANTERAT ||
    momshantering == null
  ) {
    return 0;
  } else {
    if (
      momshantering ===
      TEDLRLeverantorfakturaMOMSHANTERINGEnum.SVENSK__ENLIGT_LEVERANTOR
    ) {
      if (registreratMomsBelopp != 0) {
        return 1;
      } else {
        return 2;
      }
    } else if (
      momshantering ===
      TEDLRLeverantorfakturaMOMSHANTERINGEnum.SVENSK__ENLIGT_KODDEL
    ) {
      if (momspliktigVerksamhet == false) {
        return 3;
      } else {
        return 4;
      }
    } else if (
      momshantering ===
      TEDLRLeverantorfakturaMOMSHANTERINGEnum.UTLANDSK__ENLIGT_KODDEL
    ) {
      return 5;
    } else if (
      momshantering ===
      TEDLRLeverantorfakturaMOMSHANTERINGEnum.UTLANDSK__ENLIGT_LEVERANTOR
    ) {
      return 6;
    }

    return 0;
  }
};

/**
 *
 * @param baselineValue Value to compare with
 * @param marginOfError Margin of error
 * @param valueToCheck Value to check if it's within the margin of error
 * @returns If given value is within the margin of error
 */
export const isNumberWithinMarginOfError = (
  baselineValue: number,
  marginOfError: number | string,
  valueToCheck: number
): boolean => {
  const marginOfErrorNumber =
    typeof marginOfError === 'string'
      ? parseFloat(marginOfError)
      : marginOfError;

  // Toleransen i Windows Aveny är i storleken ex 5 men behöver divideras med 1000 för att få 0.005 dvs 0.5% felmarginal
  const marginOfErrorFloat = marginOfErrorNumber / 1000;

  const lowerBound = baselineValue - marginOfErrorFloat;
  const upperBound = baselineValue + marginOfErrorFloat;

  if (baselineValue === valueToCheck) {
    return true;
  } else if (lowerBound <= valueToCheck && valueToCheck < baselineValue) {
    return true;
  } else if (baselineValue < valueToCheck && valueToCheck <= upperBound) {
    return true;
  } else {
    return false;
  }
};
